/**
 * The exact `?tab=` values the backend accepts and the keys of its `counts`
 * envelope, so they double as the lookup key for the tab badges. Membership,
 * ordering and pagination are all decided server-side.
 */
export const TABS = {
  UPCOMING: "upcoming",
  NEEDS_ATTENTION: "needs_attention",
  ALL: "all",
};

/**
 * `upcoming` and `needs_attention` return every row (the backend caps them at
 * 500); only `all` is paginated. The list must not render a pager for the
 * unpaginated tabs — the backend ignores `page` there and would return the
 * same rows for every page.
 */
export const isPaginatedTab = (tab) => tab === TABS.ALL;
